import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { ButtonIcon } from "../ButtonIcon";
import IconChevronLeft from "../Icon/IconChevronLeft";
import IconChevronRight from "../Icon/IconChevronRight";
import Container from "./Container";
import Label from "./Label";
var propTypes = {
  onIncrement: PropTypes.func,
  onDecrement: PropTypes.func,
  theme: PropTypes.shape({
    paginationControls: PropTypes.oneOf(['dark'])
  }),
  children: PropTypes.node
};
var defaultProps = {
  theme: {}
};
var ThemedButtonIcon = styled(function (_ref) {
  var disabled = _ref.disabled,
      rest = _objectWithoutProperties(_ref, ["disabled"]);

  return React.createElement(ButtonIcon, rest);
}).attrs(function (props) {
  return {
    theme: props.theme.paginationControls === 'dark' ? ButtonIcon.darkTheme : {}
  };
}).withConfig({
  displayName: "PaginationControls__ThemedButtonIcon",
  componentId: "sc-1s7ejok-0"
})(["", ";"], function (props) {
  return props.disabled && css(["opacity:0.4;pointer-events:none;"]);
});
export default function PaginationControls(_ref2) {
  var onIncrement = _ref2.onIncrement,
      onDecrement = _ref2.onDecrement,
      theme = _ref2.theme,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["onIncrement", "onDecrement", "theme", "children"]);

  return React.createElement(Container, props, children && React.createElement(Label, null, children), React.createElement(ThemedButtonIcon, {
    "aria-label": "Backward button",
    onClick: onDecrement,
    disabled: typeof onDecrement === 'undefined'
  }, React.createElement(IconChevronLeft, {
    iconSize: 16
  })), React.createElement(ThemedButtonIcon, {
    "aria-label": "Forward button",
    onClick: onIncrement,
    disabled: typeof onIncrement === 'undefined'
  }, React.createElement(IconChevronRight, {
    iconSize: 16
  })));
}
PaginationControls.darkTheme = {
  paginationControls: 'dark'
};
PaginationControls.propTypes = propTypes;
PaginationControls.defaultProps = defaultProps;